import React from 'react';

export const GamesJackpot = React.lazy(() => import(/* webpackChunkName: "games-jackpot" */ './GamesJackpot'));
